export const orderLineTotal = item => item.finalLineTotal
  ?? (Number(item.discountedPrice ?? item.price) || 0) * (Number(item.quantity) || 0);

// A whole-UAH line total may not divide into identical whole-UAH unit prices.
// Invoice rows split into at most two groups to preserve both quantity and total.
export const invoiceLineGroups = item => {
  const quantity = Number(item.quantity) || 0;
  if (!quantity) return [];
  const total = orderLineTotal(item);
  const unitPrice = Math.floor(total / quantity);
  const remainder = total - unitPrice * quantity;
  return [
    ...(quantity > remainder ? [{ quantity: quantity - remainder, price: unitPrice, sum: unitPrice * (quantity - remainder) }] : []),
    ...(remainder > 0 ? [{ quantity: remainder, price: unitPrice + 1, sum: (unitPrice + 1) * remainder }] : []),
  ];
};
